/* tslint:disable */
/* eslint-disable */
/**
 * Linqx API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WaitlistResponse
 */
export interface WaitlistResponse {
    /**
     * Whether the operation was successful
     * @type {boolean}
     * @memberof WaitlistResponse
     */
    success: boolean;
    /**
     * User friendly status message
     * @type {string}
     * @memberof WaitlistResponse
     */
    message: string;
    /**
     * Position in the waitlist (approximate)
     * @type {number}
     * @memberof WaitlistResponse
     */
    position?: number;
}

/**
 * Check if a given object implements the WaitlistResponse interface.
 */
export function instanceOfWaitlistResponse(value: object): value is WaitlistResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function WaitlistResponseFromJSON(json: any): WaitlistResponse {
    return WaitlistResponseFromJSONTyped(json, false);
}

export function WaitlistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaitlistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'position': json['position'] == null ? undefined : json['position'],
    };
}

export function WaitlistResponseToJSON(json: any): WaitlistResponse {
    return WaitlistResponseToJSONTyped(json, false);
}

export function WaitlistResponseToJSONTyped(value?: WaitlistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'position': value['position'],
    };
}

